import Vue      from 'vue';
import axios    from 'axios';
import store    from '@/vuex/store';
import SDLUtil  from '@/utils/SDLUtil';

const fetchCode = (comboVal, comboCd, userCompanyCode) =>
    axios.get(`${SDLUtil.API_URL}/basis/common/codeAjax.skp?codeCategoryId=${comboCd}&parentCode=${comboVal}&addCondition1=${userCompanyCode}`);

const fetchCommonCode = (comboCd, status, lang) =>
    axios.get(`${SDLUtil.API_URL}/basis/common/getCodeList.skp?codeCategoryId=${comboCd}&status=${status}&locale=${lang}`);

export default {
    async getComboList(comboVal, comboCd, userCompanyCode) {
        try {
            let userCorpCode = userCompanyCode || store.getters.getCorpCd || '';
            const codeResponse = await fetchCode(comboVal, comboCd, userCorpCode);
            if(codeResponse.data !== null) {
                if(codeResponse.data.result.length > 0) {
                    return this.reworkCode(codeResponse.data.result);

                } else {
                    return [];
                }
            }

            return [];

        } catch (err) {
            // Vue.$log.error('login:', err);
        }
    },
    async getCommonCodeList(comboCd, stat, lang) {
        try {
            const codeResponse = await fetchCommonCode(SDLUtil.nvl(comboCd), SDLUtil.nvl(stat), SDLUtil.nvl(lang));
            if (codeResponse.data !== null) {
                if(codeResponse.data.result.rowData.length > 0) {
                    return this.reworkCommonCode(codeResponse.data.result.rowData);

                } else {
                    return [];
                }
            }

            return [];

        } catch (err) {
            // Vue.$log.error('login:', err);
        }
    },
    async getCommonHardCodeList(comboCd) {
        try {
            let commonCode = [];
            if ('TOOL_STATUS' === comboCd) {
                commonCode.push({ code: 'Draft',      codeName: 'Draft' });
                commonCode.push({ code: 'Ongoing',    codeName: 'Ongoing' });
                commonCode.push({ code: 'Release',    codeName: 'Release' });
                commonCode.push({ code: 'Processing', codeName: 'Processing' });
                commonCode.push({ code: 'Complete',   codeName: 'Complete' });
                commonCode.push({ code: 'Rejected',   codeName: 'Rejected' });
                commonCode.push({ code: 'Canceled',   codeName: 'Canceled' });
                commonCode.push({ code: 'Discard',    codeName: 'Discard' });
                commonCode.push({ code: 'Expired',    codeName: 'Expired' });
                commonCode.push({ code: 'Error',      codeName: 'Error' });
            } else if ('TOOL_STEP' === comboCd) {
                commonCode.push({ code: 'Q', codeName: 'QA', index: 1});
                commonCode.push({ code: 'T', codeName: 'GBM TEST', index: 2});
                commonCode.push({ code: 'P', codeName: 'Pilot', index: 3});
                commonCode.push({ code: 'O', codeName: 'Public', index: 4});
            }

            return commonCode;
            
        } catch (err) {
            // Vue.$log.error('login:', err);
        }
    },
    reworkCode(codeObj) {
        let codeList = [];
        for(let i = 0; i < codeObj.length; i++) {
            let key = 'code' + String(i);
            codeList.push(codeObj[key]);
        }

        return codeList;
    },
    reworkCommonCode(codeObj) {
        let codeList = [];
        for(let i = 0; i < codeObj.length; i++) {
            codeList.push({
                code: codeObj[i].CD,
                codeName: codeObj[i].CDNM
            });
        }

        return codeList;
    }
};


// WEBPACK FOOTER //
// ./src/service/skpCommonService.js